module.exports = __webpack_public_path__ + "img/Participation.dfe21034.svg";